<template>
	<div class="container">
		<div class="ul-score">
			<mt-header class="header" title="签到送积分">
			<header-item slot="left" v-bind:isBack=true v-on:onclick="goBack">
			</header-item>
			<!-- <div class="right" slot="right" @click="goRecord">
				<img src="../../assets/image/change-icon/btn_rule@2x.png">积分规则</div> -->
			</mt-header>		
			<div class="header-info">			
				<div class="title">
					{{score}}
				</div>
				<div class="desc">
					当前积分
					<!-- <img @click="touchExplain()" src="../../assets/image/change-icon/btn_integral@2x.png"> -->
				</div>
				<mt-button v-if="issignin==0"  :plain="true" @click="dailySignin"  style="border-radius: 50px;width: 100px;margin-top: 10px;">未签到</mt-button>
				<mt-button v-else  :plain="true"  style="border-radius: 50px;width: 100px;margin-top: 10px;">已签到</mt-button>
			</div>		
			<!-- <div class="tab">
				<ul>
					<li class="tab-item" v-bind:class="{'active': currentIndex == 0}" @click="setCurrentItem(0)">全部</li>
					<li class="tab-item" v-bind:class="{'active': currentIndex == 1}" @click="setCurrentItem(1)">收入</li>
					<li class="tab-item" v-bind:class="{'active': currentIndex == 2}" @click="setCurrentItem(2)">支出</li>
				</ul>
			</div> -->
		</div>
		<recommend-item style="position: absolute;top: 210px;"></recommend-item>

		<!-- <div class="list" v-infinite-scroll="getMore" infinite-scroll-disabled="canNotLoadMoer" infinite-scroll-distance="10">
			<score-record
				class="item"
				v-for="(item, index) in recordList"
				:key="index"
				:item="item">
			</score-record>
		</div>		 -->
		<!-- <div v-if="(!recordList.length) " class="empty">
			<img src="../../assets/image/change-icon/e2_wu@2x.png">
			<div class="desc">暂无积分纪录</div>
		</div> -->
	</div>
</template>

<script>

import HeaderItem  from '../../components/common'
import ScoreItem from './child/ScoreItem'
import ScoreRecord from './child/ScoreRecord'
import RecommendItem from './child/RecommendItem'
import * as api from '../../api/score'
import { MessageBox, Toast } from 'mint-ui'

export default {
	data() {
		return {
			scoreInfo: {},
			recordList: [],  // 记录列表
			requestParams: {'page': 0, 'per_page': 10},  //获取优惠券列表的接口
			loading: false,  //是否加载更多
			isMore: true,  //是否有更多
			currentIndex: this.$route.query.index,  //当前的tab			
			score:null,
			issignin:null,
		}
	},
	created() {
		this.getScoreInfo();
		this.signInStatus();
	},
	mounted() {

	},
	computed: {
	  canNotLoadMoer: function () {
	    return this.loading || !this.isMore;
	  },
	},
	methods: {
		touchExchange(item) {
			api.scoreExchangeCoupon(item.id).then(res => {
				if ( res ) {	
					Toast('积分兑换成功')	
					this.getScoreInfo();			
				}
			}, error => {								
				Toast({
				  message: error.errorMsg,				  
				  duration: 1000
				});
			});
		},
		dailySignin(){
			api.dailySignIn(this.score?this.score:1).then(res => {
				if ( res ) {	
					Toast('签到成功')
					this.signInStatus();
				}
			}, error => {								
				Toast({
				  message: error.errorMsg,				  
				  duration: 1000
				});
			});
		},
		signInStatus(){
			api.signInStatus().then(res => {
				if ( res  && res.error_code == 0) {	
					this.issignin = res.issignin;  //"issignin": 0,  是否签到过了，  0 没有签到， 1签过到了
					this.score = res.score;
				}
			}, error => {								
				Toast({
				  message: error.errorMsg,				  
				  duration: 1000
				});
			});
		},
		goBack() {
			this.$router.go(-1)
		},
		goRecord() {
			this.$router.push("/scoreRule");
		},		
		getScoreInfo() {
			api.scoreGet().then(res => {
				if ( res ) {
					this.scoreInfo = res;
				}
			});
		},
		// 获取兑换记录列表
		getScoreList() {
			let data = this.requestParams;
			let status = this.currentIndex;
			api.scoreExchangeCouponRecordList(data.page, data.per_page,status).then(res => {
				this.loading = false;
				if ( res ) {
					this.recordList = this.recordList.concat(res.history);
					this.isMore = res.paged.more == 1 ? true : false;
				}else{

					
				}
			},error => {
				this.loading = false;
				this.isMore = false;
			});
		},

		// 解释
		touchExplain() {
			MessageBox({
				title: "",				
				message: "即将到账的积分将在付款成功后</br>自动充值到总积分当中！",
				confirmButtonText: "知道了",
				confirmButtonClass: "confirm-button-red"
			});
		},
		setCurrentItem(index) {
			if ( index == this.currentIndex ) {
				return;
			}
			this.requestParams = {'page': 0, 'per_page': 10};
			this.currentIndex = index;
			this.recordList = [];
			this.isMore = true;
			this.getMore();
		},
		/*
		 * getMore: 无限滚动加载
		 */
		getMore() {			
			this.loading = true;
			this.requestParams.page = ++this.requestParams.page;
			
			if ( this.isMore ) {
				this.getScoreList();
			}
		}
	},
	components: {
		ScoreItem,
		ScoreRecord,
		RecommendItem
	}
}
</script>

<style lang="scss" scoped>
	.container {
		background-color: #FFFFFF;
		height: 100%;
		.ul-score {
			position: fixed;
			width: 100%;
			z-index: 100;
			.header-info {
				width: 100%;
				height: 170px;
				background: url('../../assets/image/change-icon/e2_bg@2x.png') no-repeat;
				background-size: cover;
				color: #fff;
				font-size: 18px;
				text-align: center;
				.title {
					font-size: 36px;
					padding-top: 28px;
				}
				.desc {
					margin-top: 12px;
					img {
						width: 16px;
						height: 16px;
						display: inline-block;
						vertical-align: middle;		
						margin-top: -3px;			
					}
				}			
			}
			.tab {
				height: 50px;
				line-height: 50px;
				background:rgba(255,255,255,1);
				border-top: 1px solid #E8EAED;
				border-bottom: 1px solid #E8EAED;
				ul {
					padding: 0px;
					margin: 0px;
					list-style: none;
					display: flex;
					justify-content: space-around;
					align-content: center;
					align-items: center;
					li {
						height: -webkit-fill-available;
						padding: 0px 10px;
						font-size:14px;
						color:rgba(124,127,136,1);
						border-bottom: 2px solid;
						border-bottom-color: transparent;
						&.active {
							color:$primaryColor;
							border-bottom-color: $primaryColor;
						}
					}
				}
			}
		}
		.list {
			margin-top: 10px;
			position: absolute;
			top: 265px;
			width: 100%;
		}
		.empty {
			padding-top: 350px;
			text-align: center;
			img {
				width: 75px;
				height: 75px;
			}
			.desc {
				margin-top: 30px;
				font-size: 18px;
				color: #A0A0A0;
			}
		}
	}
	.header {
		@include header;
		.right {
			font-size: 14px;
			color: #404245;
			img {
				width: 16px;
				height: 16px;
				vertical-align: middle;
				margin-right: 2px;
				margin-top: -4px;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/score/ScoreSignIn.vue